// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n[data-v-06b07824] .ant-modal-body {\n  padding: 0;\n}\n.dialog-style[data-v-06b07824] {\n  padding-bottom: 73px;\n}\n[data-v-06b07824] .modal-container {\n  height: 100%;\n}\n[data-v-06b07824] .modal-scrollbar {\n  overflow-x: hidden;\n  padding: 20px;\n}\n", ""]);
// Exports
module.exports = exports;
